import { useQuery } from "@tanstack/react-query";
import { getAdminLoyaltyPointsHistory } from "../../admin/loyalty/loyaltyApi";
export const adminLoyaltyPointsKey = "loyalty-points-history-admin";

export const useAdminLoyaltyPointsHistory = (userIds: Array<string>, page: number, size: number) => {
  const hasUsers = userIds.length > 0;
  // request one more item than asked so we can tell if there is a next page
  const requestSize = size + 1;
  const { data, isLoading } = useQuery({
    queryKey: [adminLoyaltyPointsKey, userIds.join(","), page, size],
    queryFn: ({ signal }) => getAdminLoyaltyPointsHistory(userIds, page, requestSize, signal),
    placeholderData: (p) => p,
    enabled: hasUsers,
  });

  if (!hasUsers) {
    return {
      loyaltyPointsHistory: [],
      isLoading: false,
      hasNext: false,
    };
  }

  const items = data ?? [];
  const hasNext = items.length > size;
  const loyaltyPointsHistory = hasNext ? items.slice(0, size) : items;

  return {
    loyaltyPointsHistory,
    isLoading,
    hasNext,
  };
};
